import { gql } from "@apollo/client";

export const GET_ALL_FRECUENCIA_MODO_DESPACHO = gql`
query allFrecuenciaModoDespacho{
    allFrecuenciaModoDespacho{
        idFrecuenciaModoDespacho,
        descripcion
    }
  }
`;